import Crud from './crud'
var crud = new Crud('report-bigpackage', 'báo cáo chi phí vận chuyển TQ-VN');

const state = {
    ...crud.state,
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
};
const mutations = {
    ...crud.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};